(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const applyAccordionState = () => {
      const showAccordionOnMobile =
        document.querySelector('[data-show-accordion]')?.getAttribute('data-show-accordion') === 'true';
      const isMobile = window.matchMedia('(max-width: 767px)').matches;
      document.querySelectorAll('details[data-footer-accordions]').forEach((el) => {
        if (showAccordionOnMobile && isMobile) {
          el.removeAttribute('open', '');
        } else if (!showAccordionOnMobile && isMobile) {
          // Do not show accordion on mobile if setting disallows
          el.setAttribute('open', true);
        } else if (!isMobile) {
          // On desktop, always open accordions
          el.setAttribute('open', '');
        }
      });
    };
    applyAccordionState();
    window.addEventListener('resize', applyAccordionState);
    document.addEventListener('shopify:section:load', (event) => {
      // Apply accordion state when a new section is loaded
      applyAccordionState();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-comparison"] && !Shopify.designMode) return;
  try {
    
  /*
  class ImageComparison extends HTMLElement {
    constructor() {
      super();
      this.active = false;
    }

    get iconButtons() {
      return this.querySelectorAll('[data-drag-button]');
    }

    get layout() {
      return this.getAttribute('data-layout');
    }

    get bounding() {
      return this.getBoundingClientRect();
    }

    addClasses() {
      lockBodyScroll();
      this.active = true;
      this.iconButtons.forEach((btn) => btn.classList.add('animating'));
    }

    removeClasses() {
      unlockBodyScroll();
      this.active = false;
      this.iconButtons.forEach((btn) => btn.classList.remove('animating'));
    }

    init() {
      const iconButtons = this.iconButtons;
      if (!iconButtons.length) {
        // console.error('Error: No [data-drag-button] found inside <image-comparison>.');
        return;
      }

      iconButtons.forEach((btn) => {
        btn.addEventListener('mousedown', this.addClasses.bind(this));
        btn.addEventListener('touchstart', this.addClasses.bind(this));
      });

      // document.body.addEventListener('mouseup', this.removeClasses.bind(this));
      // document.body.addEventListener('mouseleave', this.removeClasses.bind(this));
      document.body.addEventListener('touchend', this.removeClasses.bind(this));
      document.body.addEventListener('touchcancel', this.removeClasses.bind(this));

      document.body.addEventListener('mousemove', (e) => {
        if (!this.active) return;
        let x =
          this.layout === 'horizontal' ? e.pageX - this.bounding.left : e.pageY - (this.bounding.top + window.scrollY);
        this.movecurs(x);
      });

      document.body.addEventListener('touchmove', (e) => {
        if (!this.active) return;
        let x =
          this.layout === 'horizontal'
            ? e.touches[0].pageX - this.bounding.left
            : e.touches[0].pageY - (this.bounding.top + window.scrollY);
        this.movecurs(x);
      });

      // Intersection Observer for triggering animation
      const observer = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              //this.animateDrag();

              observer.disconnect();
            } else {
            }
          });
        },
        { threshold: 0.8 }
      );

      observer.observe(this);
    }

    movecurs(x) {
      const distance = this.layout === 'horizontal' ? this.clientWidth : this.clientHeight;
      const max = distance - 20;
      const min = 20;
      const mouseX = Math.max(min, Math.min(x, max));
      const mousePercent = (mouseX * 100) / distance;

      this.iconButtons.forEach((btn) => {
        if (this.layout === 'horizontal') {
          btn.style.left = mousePercent + '%';
        } else {
          btn.style.top = mousePercent + '%';
        }
      });

      this.style.setProperty('--drag-position', mousePercent + '%');
    }

    animateDrag() {
      const distance = this.layout === 'horizontal' ? this.clientWidth : this.clientHeight;
      const max = distance - 20;
      const min = 20;
      let start = performance.now();
      const totalDuration = 2000;
      let currentPos = min;

      const animateRight = (time) => {
        const progress = (time - start) / totalDuration;
        if (progress < 1) {
          currentPos = min + (max - min) * progress;
          this.movecurs(currentPos);
          requestAnimationFrame(animateRight);
        } else {
          this.movecurs(max);
          setTimeout(() => {
            this.animateToMiddle();
          }, 500);
        }
      };

      requestAnimationFrame(animateRight);
    }

    animateToMiddle() {
      const distance = this.layout === 'horizontal' ? this.clientWidth : this.clientHeight;
      const max = distance - 20;
      const min = 20;
      const middle = (min + max) / 2;
      let start = performance.now();
      const totalDuration = 1000;

      const animateMiddle = (time) => {
        const progress = (time - start) / totalDuration;
        if (progress < 1) {
          const currentPos = max - (max - middle) * progress;
          this.movecurs(currentPos);
          requestAnimationFrame(animateMiddle);
        } else {
          this.movecurs(middle);
        }
      };

      requestAnimationFrame(animateMiddle);
    }

    connectedCallback() {
      this.init();
    }
  }

  customElements.define('image-comparison', ImageComparison);

  */
  // Helper functions for body scroll control

  class ImageComparison extends HTMLElement {
    constructor() {
      super();
      this.active = false;

      // Bind all event handlers once
      this.boundAddClasses = this.addClasses.bind(this);
      this.boundRemoveClasses = this.removeClasses.bind(this);
      this.boundMouseMove = this.handleMouseMove.bind(this);
      this.boundTouchMove = this.handleTouchMove.bind(this);
    }

    get iconButtons() {
      return this.querySelectorAll('[data-drag-button]');
    }

    get layout() {
      return this.getAttribute('data-layout') || 'horizontal';
    }

    get bounding() {
      return this.getBoundingClientRect();
    }

    addClasses() {
      lockBodyScroll();
      this.active = true;
      this.iconButtons.forEach((btn) => btn.classList.add('animating'));

      // Add temporary event listeners
      document.addEventListener('mousemove', this.boundMouseMove);
      document.addEventListener('touchmove', this.boundTouchMove, { passive: false });
      document.addEventListener('mouseup', this.boundRemoveClasses);
      document.addEventListener('mouseleave', this.boundRemoveClasses);
      document.addEventListener('touchend', this.boundRemoveClasses);
      document.addEventListener('touchcancel', this.boundRemoveClasses);
    }

    removeClasses() {
      unlockBodyScroll();
      this.active = false;
      this.iconButtons.forEach((btn) => btn.classList.remove('animating'));

      // Clean up temporary event listeners
      document.removeEventListener('mousemove', this.boundMouseMove);
      document.removeEventListener('touchmove', this.boundTouchMove);
      document.removeEventListener('mouseup', this.boundRemoveClasses);
      document.removeEventListener('mouseleave', this.boundRemoveClasses);
      document.removeEventListener('touchend', this.boundRemoveClasses);
      document.removeEventListener('touchcancel', this.boundRemoveClasses);
    }

    handleMouseMove(e) {
      if (!this.active) return;
      const x =
        this.layout === 'horizontal' ? e.pageX - this.bounding.left : e.pageY - (this.bounding.top + window.scrollY);
      this.movecurs(x);
    }

    handleTouchMove(e) {
      if (!this.active) return;
      e.preventDefault(); // Prevent scrolling while dragging
      const touch = e.touches[0];
      const x =
        this.layout === 'horizontal'
          ? touch.pageX - this.bounding.left
          : touch.pageY - (this.bounding.top + window.scrollY);
      this.movecurs(x);
    }

    movecurs(x) {
      const distance = this.layout === 'horizontal' ? this.clientWidth : this.clientHeight;
      const max = distance - 20;
      const min = 20;
      const mouseX = Math.max(min, Math.min(x, max));
      const mousePercent = (mouseX * 100) / distance;

      this.iconButtons.forEach((btn) => {
        if (this.layout === 'horizontal') {
          btn.style.left = mousePercent + '%';
        } else {
          btn.style.top = mousePercent + '%';
        }
      });

      this.style.setProperty('--drag-position', mousePercent + '%');
    }

    init() {
      const iconButtons = this.iconButtons;
      if (!iconButtons.length) return;

      // Add permanent event listeners
      iconButtons.forEach((btn) => {
        btn.addEventListener('mousedown', this.boundAddClasses);
        btn.addEventListener('touchstart', this.boundAddClasses, { passive: true });
      });

      // Intersection Observer for triggering animation
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              observer.disconnect();
            }
          });
        },
        { threshold: 0.8 }
      );

      observer.observe(this);
    }

    disconnectedCallback() {
      // Clean up all event listeners when component is removed
      this.iconButtons.forEach((btn) => {
        btn.removeEventListener('mousedown', this.boundAddClasses);
        btn.removeEventListener('touchstart', this.boundAddClasses);
      });
      this.removeClasses(); // Cleans up any active listeners
    }

    connectedCallback() {
      this.init();
    }
  }

  customElements.define('image-comparison', ImageComparison);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["products-grid"] && !Shopify.designMode) return;
  try {
    
const productGridInfos = document.querySelectorAll('[data-grid-info]');
productGridInfos.forEach((gridInfo) => {
  const priceDiv = gridInfo.querySelector('.product-price');
  if (priceDiv) {
    const priceHeight = priceDiv.offsetHeight;
    gridInfo.style.setProperty('--product-price-height', `${priceHeight}px`);
  }
});


  } catch(e) { console.error(e); }
})();
})();
